import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import SingleCategory from '../../components/Category';
import SectionTitle from '../../components/SectionTitle';
import { categoryIcons } from '../../data/images';

import shapeImg from '../../assets/img/category/ed-shape-1.png';

// Each type links to the programs list or straight to a degree. Icons come from the SANASA picture set.
const types = [
  { title: 'Banking & Finance', icon: 'banking', to: '/programs/bsc-banking-finance' },
  { title: 'Insurance & Risk', icon: 'insurance', to: '/programs/bsc-insurance-risk' },
  { title: 'Regional Science', icon: 'planning', to: '/programs/bsc-regional-science-planning' },
  { title: 'Insurance Diploma', icon: 'diplomas', to: '/programs/diploma-insurance-risk' },
  { title: 'Certificates', icon: 'training', to: '/programs?type=short' },
  { title: 'Diplomas', icon: 'diplomas', to: '/programs?type=diploma' },
  { title: 'Higher Diplomas', icon: 'diplomas', to: '/programs?type=diploma' },
  { title: 'Society Courses', icon: 'training', to: '/programs?type=short' },
  { title: 'Entrepreneur Skills', icon: 'training', to: '/programs?type=short' },
];
// Template card colours that fit the blue palette (1 = default pale blue).
const cardStyles = [1, 2, 5, 7];

const ServiceMain = () => {
  return (
    <main>
      <Breadcrumb title="Programs By Type" subTitle="Programs" />

      <div className="ed-category-area pt-120 p-relative pb-120">
        <div className="ed-category-shape-1">
          <img src={shapeImg} alt="" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <SectionTitle
                itemClass="ed-category-title-box text-center mb-70"
                subTitle="Programs"
                title="Browse Programs By Type"
              />
            </div>
          </div>
          <div className="row gx-35">
            {types.map((t, i) => (
              <div
                key={t.title}
                className="col-xl-4 col-lg-6 col-md-6 col-sm-6 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay={`${0.3 + Math.floor(i / 3) * 0.2}s`}
              >
                <SingleCategory
                  itemClass={`ed-category-item ed-category-style-${cardStyles[i % cardStyles.length]} d-flex align-items-center mb-35`}
                  icon={<img src={categoryIcons[t.icon]} alt="" width="40" height="40" />}
                  title={t.title}
                  to={t.to}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};
export default ServiceMain;
